import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

export const REINVITE_ENVELOPE_QUERY_KEYS = ['envelope']

export interface ReinviteEnvelopeResponse {
  withheldInvites: number
}

export const reinviteEnvelope = async (
  envelopeId: string,
): Promise<ReinviteEnvelopeResponse> => {
  const { data } = await apiClient.post<
    Partial<ReinviteEnvelopeResponse> | undefined
  >(`/v1/ecm/envelopes/${envelopeId}/manual-reinvite-to-review`)
  return { withheldInvites: data?.withheldInvites ?? 0 }
}

export const useReinviteEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (envelopeId: string) => reinviteEnvelope(envelopeId),
    meta: {
      invalidatesQuery: REINVITE_ENVELOPE_QUERY_KEYS,
      ...feedback,
    },
  })
}
